import { render, staticRenderFns } from "./question-item.vue?vue&type=template&id=5f9da7ba&scoped=true"
import script from "./question-item.vue?vue&type=script&lang=js"
export * from "./question-item.vue?vue&type=script&lang=js"
import style0 from "./question-item.vue?vue&type=style&index=0&id=5f9da7ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9da7ba",
  null
  
)

export default component.exports